<template>
  <div>
    <v-row class="custom-row-billing">
      <v-col>
        <div class="d-flex justify-start">
          <div class="mt-sm-2">
            <v-icon color="#000" class="mr-1"> mdi-calendar-month </v-icon>
            <span>Periodo</span>
          </div>
          <div class="mx-5 custom-select-billing-year" style="width: 150px">
            <custom-select
              v-model="period"
              :options="periods"
              :disabled="vep.loader || backorders.loading"
              label="date"
              :placeholder="'Año'"
            />
          </div>
          <div class="custom-chk mt-sm-n5 mt-md-n3">
            <v-checkbox v-model="showMore" color="info">
              <template #label>
                <div class="text-muted">Mostrar más trimestres/Meses</div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-simple-table class="my-table w-full">
      <template #default>
        <thead class="table-heading">
          <tr class="text-center">
            <th rowspan="2" class="text-center text-dark border-lr">
              Participación <br />
              de Familias
            </th>
            <th colspan="5" class="text-center boder-x-none text-dark">
              Backorder
            </th>
            <th rowspan="2" class="text-center text-dark border-lr">
              Backorder <br />
              cancelado <br />
              del mes
            </th>
            <th rowspan="2" class="text-center text-dark border-lr">
              (VEP + PFD) <br />
              VEP
            </th>
            <th
              class="text-center text-dark border-lr"
              :colspan="maxSliceTrim * -1"
            >
              <div class="d-flex justify-space-around align-center">
                <div class="mx-5 ma-1">
                  <custom-select
                    v-model="vep.option"
                    class="text-caption"
                    :disabled="vep.loader"
                    :options="vep.options"
                    :placeholder="'Pedidos por día hábil'"
                    theme="red"
                  />
                </div>
                <v-checkbox
                  v-model="quarterView"
                  class="text-caption"
                  label="Trimestral"
                  color="info"
                  :disabled="vep.loader"
                  dense
                />
                <v-checkbox
                  v-model="monthView"
                  class="text-caption"
                  label="Mensual"
                  color="info"
                  :disabled="vep.loader"
                  dense
                />
              </div>
            </th>
          </tr>
          <tr>
            <th class="text-center text-dark">Total</th>
            <th class="text-center text-dark boder-x-none">Disponible</th>
            <th class="text-center text-dark boder-x-none">Parcial</th>
            <th class="text-center text-dark boder-x-none">Sin inventario</th>
            <th class="text-center text-dark boder-x-none">Programado</th>
            <template v-if="quarterView">
              <th
                v-for="(item, index) in vepQuarterlyHeader.slice(maxSliceTrim)"
                :key="index"
                class="text-center text-dark boder-x-none"
              >
                {{ item.date }} {{ item.businessDays }} <br />
                VEP + PFD
              </th>
            </template>
            <template v-else>
              <th
                v-for="(item, index) in vepMonthlyHeader.slice(maxSliceTrim)"
                :key="index"
                class="text-center text-dark boder-x-none"
              >
                {{ item.date }} {{ item.businessDays }} <br />
                VEP + PFD
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr class="font-weight-bold">
            <template v-if="!backorders.loading">
              <td>
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <a @click="getSalesByArea()">
                      <v-icon v-bind="attrs" color="#B71C1C" v-on="on"
                        >mdi-chart-pie</v-icon
                      >
                    </a>
                  </template>
                  <span>Mostrar participación/ Divisiones</span>
                </v-tooltip>
              </td>
              <td>
                {{ formatNumber(backorders.data?.backorders.total, '$', 0) }}
              </td>
              <td class="in-stock-text">
                {{ formatNumber(backorders.data?.backorders.inStock, '$', 0) }}
              </td>
              <td class="partial-stock-text">
                {{
                  formatNumber(backorders.data?.backorders.partialStock, '$', 0)
                }}
              </td>
              <td class="no-stock-text">
                {{ formatNumber(backorders.data?.backorders.noStock, '$', 0) }}
              </td>
              <td class="programmed-stock-text">
                {{
                  formatNumber(
                    backorders.data?.backorders.programmedStock,
                    '$',
                    0
                  )
                }}
              </td>
              <td>
                {{ formatNumber(backorders.data?.backorders.canceled, '$', 0) }}
              </td>
            </template>
            <template v-else>
              <td colspan="7">
                <v-progress-circular indeterminate color="primary" />
              </td>
            </template>
            <template v-if="backorders.error">
              <td colspan="7">
                <alert-prominent
                  :message="backorders.error"
                  :dismissible="true"
                />
              </td>
            </template>

            <td>
              <v-progress-circular
                v-if="vepPfd.loader"
                indeterminate
                color="primary"
              />
              <a v-else>
                <span class="text-danger">
                  {{
                    formatFloat(
                      vepPfd.data == '' ? 0 : vepPfd.data[0].porcentVEPPFD
                    )
                  }}%
                </span>
                <br />
                <span class="text-danger">
                  {{
                    formatFloat(
                      vepPfd.data == '' ? 0 : vepPfd.data[0].porcentVEP
                    )
                  }}%
                </span>
              </a>
              <alert-prominent
                v-if="vepPfd.error"
                :message="vepPfd.error"
                :dismissible="true"
              />
            </td>
            <td
              v-if="vep.loader"
              colspan="8"
              class="justify-content-center align-items-center"
            >
              <v-progress-circular indeterminate color="primary" />
            </td>
            <template v-else>
              <template v-if="vep.option == 3">
                <td
                  v-for="(item, index) in vep.data.slice(maxSliceTrim)"
                  :key="index"
                >
                  <b>{{ formatFloat(item.daysDiff, 0) }}</b>
                </td>
              </template>
              <template v-else>
                <td
                  v-for="(item, index) in vep.data.slice(maxSliceTrim)"
                  :key="index"
                >
                  <a>
                    <b>{{
                      avgAmount(item.amount, item.header.businessDays)
                    }}</b> </a
                  ><br />
                  <b class="small">{{ formatFloat(item.percent) }}%</b>
                </td>
              </template>
            </template>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <graph
      v-model="salesByArea.modal"
      :char-title="salesByArea.charTitle"
      :loading="salesByArea.loading"
      :data="salesByArea.data"
      :errors="salesByArea.error"
      @onPeriodChange="updateSalesByArea"
    />
  </div>
</template>

<script>
  import mixinService from '@/mixins/service';
  import moment from 'moment';
  import Quarter from '@/core/models/quarter';

  import dates from '@/mixins/dates';
  import numbersFormats from '@/mixins/numbersFormats';

  import CustomSelect from '@/components/CustomSelect.vue';
  import Graph from '@/views/daily/modals/Graph.vue';
  import AlertProminent from '@/components/AlertProminent.vue';

  import axios from '@/plugins/axios';

  export default {
    name: 'Backorders',
    components: { CustomSelect, Graph, AlertProminent },
    mixins: [mixinService, dates, numbersFormats],
    props: {
      seller: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        showMore: false,
        loadingBilling: true,
        backorders: {
          loading: true,
          data: [],
          error: '',
        },
        period: null,
        periods: [],
        vep: {
          //Successful planned visits on business days
          options: [
            {
              value: 1,
              label: 'Pedidos por día hábil',
            },
            { value: 2, label: 'Fact neta por día hábil' },
            { value: 3, label: 'Tiempo de entrega de pedidos' },
          ],
          option: 1,
          data: [],
          loader: true,
        },
        vepPfd: {
          //Unsuccessful planned visits on business days + Successful planned visits on business days
          loader: true,
          data: [],
          error: '',
        },
        vepQuarterlyHeader: [],
        vepMonthlyHeader: [],
        maxSliceTrim: -4,
        monthView: false,
        quarterView: true,
        salesByArea: {
          loading: true,
          data: [],
          modal: false,
          error: null,
          year: null,
          quarter: null,
          charTitle: '',
        },
      };
    },

    watch: {
      'vep.option': function () {
        this.getInfoFactTrim();
      },
      showMore(value) {
        this.maxSliceTrim = value ? -8 : -4;
      },
      seller() {
        this.sellerBackorders();
        this.getInfoFactTrim();
        this.getVepPfd();
      },
      period() {
        if (this.seller.PERNR) {
          this.vepQHeader();
          this.vepMHeader();
          this.getInfoFactTrim();
          this.getVepPfd();
        }
      },
      quarterView(value) {
        if (value) {
          this.monthView = false;
          this.getInfoFactTrim();
        } else {
          if (!this.monthView) this.monthView = true;
        }
      },
      monthView(value) {
        if (value) {
          this.quarterView = false;
          this.getInfoFactTrim();
        } else {
          if (!this.quarterView) this.quarterView = true;
        }
      },
    },
    created() {
      var dates = this.calcularUltimosMeses(24);
      this.periods = dates.map((item) => ({
        label: item.date,
        value: this.periodFormat(item),
        year: item.year,
        month: item.month,
      }));
      this.period = this.periods[0].value;
      const quarters = this.getQuartersList(1);
      this.salesByArea.quarter = quarters[0].quarter;
      this.salesByArea.year = quarters[0].year;
      this.vepQHeader();
      this.vepMHeader();
    },
    methods: {
      async getSalesByArea(period = null) {
        (this.salesByArea.error = ''),
          (this.salesByArea.charTitle = `Participación por division del Asesor ${this.seller.PERNR}`);
        this.salesByArea.loading = true;
        this.salesByArea.modal = true;
        period = period ? period : this.salesByArea;
        try {
          const response = await axios.get('daily/sales-by-area', {
            params: {
              user: this.seller.PERNR,
              quarter: period.quarter,
              year: period.year,
              channel: this.seller.VTWEG,
            },
          });
          this.salesByArea.data = response.data.items;
        } catch (error) {
          this.salesByArea.error = error;
          this.salesByArea.loading = false;
        }
        this.salesByArea.loading = false;
      },
      async getVepPfd() {
        this.vepPfd.loader = true;
        this.vepPfd.error = '';
        let period = this.removeTimeFromDate(
          this.period,
          'YYYYMM',
          'M-YYYY'
        ).split('-');
        try {
          let response = await axios.get('/seller/home/historico-veppfd', {
            params: {
              employee_number: Number(this.seller.PERNR),
              P_VTWEG: this.seller.VTWEG,
              number_month: period[0],
              number_year: period[1],
            },
            noCancelRequest: true,
            cachable: true,
          });

          this.vepPfd.data = response.data.data;
          this.vepPfd.loader = false;
        } catch (error) {
          this.vepPfd.error = error;
          this.vepPfd.loader = false;
        }
      },
      async getInfoFactTrim() {
        this.vep.loader = true;
        let period = this.removeTimeFromDate(
          this.period,
          'YYYYMM',
          'M-YYYY'
        ).split('-');

        const response = await axios.get('/seller/home/dia-habil', {
          params: {
            employee_number: Number(this.seller.PERNR),
            P_VTWEG: this.seller.VTWEG,
            trim: this.quarterView
              ? moment()
                  .month(period[0] - 1)
                  .quarter()
              : '',
            month: !this.quarterView ? period[0] : '',
            year: period[1],
            opt: this.vep.option,
          },
        });
        const headers = this.monthView
          ? this.vepMonthlyHeader
          : this.vepQuarterlyHeader;
        this.vep.data = this.enrichHeaders(
          headers,
          response.data.data.reverse()
        );
        this.vep.loader = false;
      },
      async sellerBackorders() {
        this.backorders.loading = true;
        this.backorders.data = [];
        this.backorders.error = '';
        try {
          const response = await axios.get('/daily/backorders', {
            params: {
              user: this.seller.PERNR,
              channel: this.seller.VTWEG,
              period: this.period,
            },
          });
          this.backorders.data = response.data;
        } catch (error) {
          this.backorders.error = error.response.data.error;
        }
        this.backorders.loading = false;
      },
      enrichHeaders(headers, data) {
        const map = new Map();
        data.forEach((item) =>
          map.set(
            this.quarterView
              ? `${item.trim}/${item.year}`
              : `${Number(item.month)}/${item.year}`,
            item
          )
        );
        return headers.map((h) => {
          const item = map.get(h.date);
          return {
            header: h,
            amount: item?.monto || 0,
            percent: item?.porcentaje || 0,
            daysDiff: item?.diasDiferencia || 0,
          };
        });
      },
      updateSalesByArea(period) {
        this.salesByArea.year = period.year;
        this.salesByArea.quarter = period.quarter;
        this.getSalesByArea(period, period.division);
      },
      vepMHeader() {
        const period = this.removeTimeFromDate(
          this.period,
          'YYYYMM',
          'MM-YYYY'
        ).split('-');
        let months = this.calcularUltimosMeses(8, period[0], period[1]);
        const cuMonth = months[0]; // current month
        months = [...months].reverse();
        this.vepMonthlyHeader = months.map((item) => {
          const date = `${item.month}/${item.year}`;
          let businessDays = 0;
          if (item == cuMonth) {
            businessDays = this.countBusinessDaysUpToToday();
          } else {
            businessDays = this.countBusinessDaysInMonth(date, 'M/YYYY');
          }
          return {
            date: `${item.month}/${item.year}`,
            trimOrMonth: item.month,
            year: item.year,
            businessDays: businessDays,
          };
        });
      },
      vepQHeader() {
        const period = this.removeTimeFromDate(
          this.period,
          'YYYYMM',
          'MM-YYYY'
        ).split('-');
        let quarters = this.calcularUltimosTrim(8, period[0], period[1]);
        const cuQuarter = quarters[0]; // current quarter
        const reversedQuarters = [...quarters].reverse();
        this.vepQuarterlyHeader = reversedQuarters.map((item) => {
          let businessDOfQuarter = 0;
          if (item.date == cuQuarter.date) {
            const currentQuarter = Quarter.getCurrentQuarterToDateRange();
            businessDOfQuarter = this.getBusinessDaysFromDates(
              currentQuarter.startDateFormatted,
              currentQuarter.endDateFormatted
            );
          } else {
            businessDOfQuarter = this.getBusinessdatesFromQuarter(
              item.trim,
              item.year
            );
          }
          return {
            date: `${item.trim}/${item.year}`,
            trimOrMonth: item,
            year: item.year,
            businessDays: businessDOfQuarter,
          };
        });
      },
      avgAmount(amount, days) {
        const avg = days == 0 ? 0 : amount / days;
        return this.formatNumber(avg, '$', 0);
      },
    },
  };
</script>
